module.exports = __webpack_public_path__ + "img/noGood.cc421508.png";